module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/video-967211.svg";